// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"Buttons_buttonPrimary__1zXPP","buttonSecondary":"Buttons_buttonSecondary__7VJyA"};